class Menu extends HTMLElement{

  constructor() {
    super();
  }

  connectedCallback() {
    this.setWidthDivImages();
    this.setNumberColumsDivCollections();
    this.setWidthDivVideo();
  }

  setWidthDivImages(){
    this.menuTop = document.querySelector('.menus-top');
    this.menu = this.menuTop.querySelector('.menu');
    this.divImages = this.menu.querySelector('.images');
    if(this.divImages){
      if(this.divImages.childElementCount > 1){
        document.documentElement.style.setProperty('--width-images-menu', '47%');
      } else if(this.divImages.childElementCount === 1) {
        document.documentElement.style.setProperty('--width-images-menu', '27.5%');
      } else {
        document.documentElement.style.setProperty('--width-images-menu', '0');
      }
    }
  }

  setWidthDivVideo(){
    this.menuTop = document.querySelector('.menus-top');
    this.menuVideos = this.menuTop.querySelector('.videos');
    this.divVideo = this.menuVideos.querySelector('.video');
    if(this.divVideo){
      if(this.menuVideos.childElementCount > 1){
        document.documentElement.style.setProperty('--width-div-video', '50%');
      } else {
        document.documentElement.style.setProperty('--width-div-video', '100%');
      }
    }
  }

  setNumberColumsDivCollections(){
    this.menuTop = document.querySelector('.menus-top');
    this.collections = this.menuTop.querySelector('.collections');
    if(this.collections){
      if(this.collections.childElementCount == 2){
        document.documentElement.style.setProperty('--colums-collections', '1');
      } else if(this.collections.childElementCount >= 3){
        document.documentElement.style.setProperty('--colums-collections', '3');
      }
    }
  }

}

customElements.define('pp-menu', Menu);